export const SET_MESSAGE = '[mutations] set message';
export const GET_MESSAGE = '[getters] get message';